import React from 'react';
import { useLocale } from '../context/LocaleContext';
import {
  getAppMenuHelp,
  getAppStepWorkHelp,
  getAppStepWorkOnTabHelp,
  getStepsTabHelp,
  getWorkshopPageHelp,
  getWorkshopStepWorkHelp,
  getStepHelpPanelTitle,
  StepHelpKey,
  HelpSectionContent,
} from '../data/stepHelpContent';
import HelpSectionView from './HelpSectionView';
import styles from '../styles/stepHelpPanel.module.css';

interface StepHelpPanelProps {
  isOpen: boolean;
  onClose: () => void;
  stepKey: StepHelpKey;
}

function buildSections(stepKey: StepHelpKey): HelpSectionContent[] {
  if (stepKey === 'workshop') {
    return [getWorkshopPageHelp(), getWorkshopStepWorkHelp(), getAppMenuHelp()];
  }

  if (stepKey === 'steps-tab') {
    return [getStepsTabHelp(), getAppStepWorkOnTabHelp(), getAppMenuHelp()];
  }

  return [getAppStepWorkHelp(), getAppMenuHelp()];
}

const StepHelpPanel: React.FC<StepHelpPanelProps> = ({ isOpen, onClose, stepKey }) => {
  const { t } = useLocale();
  if (!isOpen) return null;

  const sections = buildSections(stepKey);

  return (
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div
        className={styles.panel}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="step-help-title"
      >
        <div className={styles.header}>
          <h2 id="step-help-title" className={styles.headerTitle}>
            {getStepHelpPanelTitle(stepKey)}
          </h2>
          <button type="button" className={styles.closeButton} onClick={onClose} aria-label={t('step.help.close_aria')}>
            ×
          </button>
        </div>
        <div className={styles.body}>
          {sections.map((section) => (
            <section key={section.title} className={styles.helpSection}>
              <h3 className={styles.sectionHeading}>{section.title}</h3>
              <HelpSectionView content={section} />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepHelpPanel;
